.stars {
  font-size: var(--text-md);
  letter-spacing: 1px;
  white-space: nowrap;
}

.good { color: var(--success); }
.fair { color: var(--warning); }
.poor { color: var(--danger); }

.starsEmpty {
  color: var(--border-strong);
}

.comment {
  color: var(--text);
  line-height: var(--leading-normal);
  /* Long comments are clamped so one review cannot dominate the table. The
     full text is still there for anyone who selects it. */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  overflow: hidden;
  max-width: 56ch;
}

.signals {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  align-items: flex-start;
}

.toggle {
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--text-muted);
  background: var(--bg);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  min-height: 34px;
}

.toggle:hover {
  background: var(--bg-hover);
  color: var(--text);
}

.toggleActive {
  background: var(--danger-soft);
  border-color: var(--danger);
  color: var(--danger);
}

.toggleActive:hover {
  background: var(--danger-soft);
  color: var(--danger);
}
